import React from "react";
import { Link, Redirect } from "react-router-dom";
import { Button, Card, CardContent, Grid } from "@mui/material";
import { ArrowBack } from "@material-ui/icons";
import { palette } from "../theme";
import LocationsForm from "../Components/LocationsForm";
import PageContainer from "../Components/UI/PageContainer";
import PageHeader from "../Components/UI/PageHeader";

export default function LocationsProfile() {
  const signedIn = global.config.uid !== "";
  const locationID = new URLSearchParams(window.location.search).get("locationID") || "";

  if (!signedIn) return <Redirect to="/" />;

  return (
    <PageContainer maxWidth={760}>
      <Button
        component={Link}
        to="/locations"
        startIcon={<ArrowBack />}
        sx={{ mb: 1, color: palette.textSecondary }}
      >
        Back to Locations
      </Button>
      <PageHeader
        title={locationID ? "Edit Location" : "Add a Location"}
        subtitle="A school or clinic, plus the rates you charge there"
      />
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <CardContent sx={{ p: 3 }}>
              <LocationsForm />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </PageContainer>
  );
}
